// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_Pz_","cls2":"SuggestedContentSidebar-cls2_45A SuggestedContentSidebar-cls1_Pz_"};